/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useEffect } from 'react';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { isExpectedApolloError } from '@confluence/error-boundary/entry-points/expectedGraphQlErrorHelper.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

import type {
	usePageTitlePageTitleQuery as usePageTitlePageTitleQuery$data,
	usePageTitlePageTitleQueryVariables as usePageTitlePageTitleQuery$variables,
} from './__types__/usePageTitlePageTitleQuery.ts';

export const usePageTitle = ({ contentId }: { contentId: string }) => {
	const { data, error } = useQuery<
		usePageTitlePageTitleQuery$data,
		usePageTitlePageTitleQuery$variables
	>(
		gql`
			query usePageTitlePageTitleQuery($contentId: ID!) {
				singleContent(id: $contentId) {
					id
					title
				}
			}
		`,
		{
			variables: { contentId },
		},
	);
	useEffect(() => {
		if (error && (isUnauthorizedError(error) || isExpectedApolloError(error))) {
			markErrorAsHandled(error);
		}
	}, [error]);
	return { title: data?.singleContent?.title, error };
};
